'use client';
import cn from 'classnames';

export default function Loader({
  isTransparentBackground,
  isLightLoader,
  isContentSizeLoader,
}: {
  isTransparentBackground?: boolean;
  isLightLoader?: boolean;
  isContentSizeLoader?: boolean;
}) {
  return (
    <div
      className={cn(
        'grid place-items-center h-full w-full inset-0 z-10',
        isContentSizeLoader ? 'static' : 'fixed',
        isTransparentBackground ? 'bg-transparent' : 'bg-gray-800/30',
      )}
    >
      <div
        className={cn(
          'rounded-[1px] overflow-hidden h-2 min-w-40 max-w-80 w-full relative',
          isLightLoader ? 'bg-gray-800' : 'bg-gray-300',
        )}
      >
        <div
          className={cn(
            'w-[200%] h-full absolute right-full animate-cross',
            isLightLoader ? 'bg-white' : 'bg-gray-800',
          )}
        />
      </div>
    </div>
  );
}
